import { atom } from "recoil";

export const subCategoriesListState = atom({
  key: "subCategoriesListState",
  default: [],
});

export default {
  subCategoriesListState,
};
